// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import OptionsDropDown from '../../../shared/components/options-drop-down';

const DemoRentalHistoryStatusCriteria = props =>
    <div className='demo-rental-status-criteria'>
        <OptionsDropDown
            className='demo-rental-status'
            isPlaceholderTranslated={false}
            isRequired={true}
            label='STATUS'
            onChange={props.onStatusChange}
            optionDisplayAttributes={['value']}
            optionKey='key'
            options={props.statuses}
            placeholder='SELECT_STATUS'
            selectedValue={props.status}
        />
    </div>;

DemoRentalHistoryStatusCriteria.displayName = 'DemoRentalHistoryStatusCriteria';
DemoRentalHistoryStatusCriteria.propTypes = {
    onStatusChange: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    statuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default DemoRentalHistoryStatusCriteria;



// WEBPACK FOOTER //
// ./src/reports/demo-rental-history/components/demo-rental-history-status-criteria.js